export default "__VITE_ASSET__d02e6073__"